import { ApiEnvelope } from '@/types/package';

/**
 * Dash Rent (`/rent/mgmt/v1`) wraps every response in `{ status, message,
 * data }`, so the payload sits one level deeper than the legacy FMS
 * endpoints. One helper instead of a copy per service module.
 */
export const unwrap = <T>(payload: ApiEnvelope<T>): T => payload?.data as T;

/**
 * Legacy `/v1` list endpoints answer either `{ status, data: T[] }` or the
 * bare array; this reads both and never returns a non-array.
 */
export const unwrapList = <T>(body: unknown): T[] => {
  const inner = (body as { data?: unknown } | null)?.data ?? body;
  return Array.isArray(inner) ? (inner as T[]) : [];
};
